// extracted by mini-css-extract-plugin
module.exports = {"time":"Time_time__21rN0"};